import { createContext, useContext } from 'react'

interface SalesEnablementContextValue {
  openRoiCalculator: () => void
}

export const SalesEnablementContext = createContext<SalesEnablementContextValue>({
  openRoiCalculator: () => {},
})

export const useSalesEnablement = () => useContext(SalesEnablementContext)
